const Routes = require('next-routes')

const routes = new Routes()
routes
  .add('home', '/', 'index')
  .add('login', '/login', 'login')
  .add('logout', '/logout', 'logout')
  .add('register', '/register', 'register')
  .add('account', '/account', 'account')
  .add('cart', '/cart', 'cart')
  .add('checkout', '/checkout', 'checkout')
  .add('electronic-service', '/electronic-service', 'electronic-service')
  .add('ids-software', '/ids-software', 'ids-software')
  .add('mdars-software', '/mdars-software', 'mdars-software')
  .add('pats-codes', '/pats-codes', 'pats-codes')
  .add('pcm-reflashing', '/pcm-reflashing', 'pcm-reflashing')
  .add('pcm-overview', '/pcm-overview', 'pcm-overview')
  .add('special-tools', '/special-tools', 'special-tools')
  .add('confirm-registration', '/confirm-registration', 'confirm-registration')
  .add('vcm-diagnostic', '/vcm-diagnostic', 'vcm-diagnostic')
  .add('invoice', '/invoice/:id', 'invoice')
  .add('faq', '/faq', 'faq')
  .add('contact', '/contact', 'contact')
  .add('forgot', '/password-reset', 'forgot')
  .add('reset', '/password-reset/:token', 'reset')
  .add('admin-index', '/admin', 'admin-index')
  .add('admin-user', '/admin/user/:id', 'admin-user')
  .add('terms-conditions', '/terms-conditions', 'terms-conditions')

module.exports = routes



// WEBPACK FOOTER //
// ./routes/index.js